import { circularGravity } from './circularGravity';
import { electromagnetism } from './electromagnetism';
import { modernPhysics } from './modernPhysics';
import { momentum } from './momentum';
import { thermal } from './thermal';
import type { PhysicsDomain } from './domainTypes';
import { orderChoices } from './choiceOrder';

export const PHYSICS_DOMAINS: PhysicsDomain[] = [
  electromagnetism,
  thermal,
  momentum,
  circularGravity,
  modernPhysics,
].map((domain, domainIndex) => ({
  ...domain,
  experiments: domain.experiments.map((experiment, experimentIndex) => ({
    ...experiment,
    prediction: orderChoices(experiment.prediction, domainIndex + experimentIndex + 1),
  })),
}));
